module.exports = __webpack_public_path__ + "media/images/result_sets/circles/3r4n6n9r-5eb4f421abf8ee7d2af686f6a8877acb.svg";